import { render, staticRenderFns } from "./GeneralIndicators.vue?vue&type=template&id=ec86b27a"
import script from "./GeneralIndicators.vue?vue&type=script&lang=ts"
export * from "./GeneralIndicators.vue?vue&type=script&lang=ts"
import style0 from "./GeneralIndicators.vue?vue&type=style&index=0&id=ec86b27a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports